import "../styles/Footer.scss";
import { Logo } from "./Logo";
import { FaCircle } from "react-icons/fa";
import { SocailIcon } from "./SocailIcon";
import { socialType } from "../utils/Enums";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "@mui/material";
import { useLocation } from "react-router-dom";

const Footer = () => {
  const { t, i18n } = useTranslation();
  const isMobile = useMediaQuery("(max-width:820px)");
  const location = useLocation();

  // Get the current language from the URL path
  const currentLanguage =
    location.pathname.split("/")[1] || i18n.language || "en";

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };
  // Add language-specific class to the footer
  const footerClass = `footer ${
    currentLanguage === "ar" ? "footer-rtl" : "footer-ltr"
  }`;

  return (
    <footer className={footerClass} lang={currentLanguage}>
      <div className="footer-left">
        <Logo titleColor="#FFFFFF" />
        {/*   <p>{t("footer_about")}</p> */}
        <div className="more-about">
          <p>{t("footer_more_about")}</p>
          <FaCircle color="white" size={".8rem"} />
        </div>
        <div className="social-icons">
          <div style={{ display: "flex", gap: ".5rem", marginTop: ".5rem" }}>
            <SocailIcon socailType={socialType.tiktok}></SocailIcon>
            <SocailIcon socailType={socialType.instagram}></SocailIcon>
            <SocailIcon socailType={socialType.snapChat}></SocailIcon>
          </div>
          <p className="copyright">{t("footer_copyright")}</p>
        </div>
      </div>
      {!isMobile && (
        <div className="footer-right">
          <nav>
            <button onClick={() => scrollToSection("HomeSection")}>
              {t("header_home")}
            </button>
            <button onClick={() => scrollToSection("AboutSection")}>
              {t("header_about_us")}
            </button>
            <button onClick={() => scrollToSection("servicesSection")}>
              {t("header_services")}
            </button>
            <button onClick={() => scrollToSection("TestimonialsSection")}>
              {t("header_testimonials")}
            </button>
          </nav>
          <div className="contact">
            <h3>{t("header_contact_us")}</h3>
            <p>+971567729666</p>
            <p>info@wecarebusiness.com</p>
          </div>
          <div className="location">
            <h3>{t("location")}</h3>
            <p>{t("office_address")}</p>
          </div>
        </div>
      )}
    </footer>
  );
};

export default Footer;
